/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-16 12:12:27
 * @LastEditTime: 2020-11-21 17:15:36
 * @LastEditors: wutt
 */
import { DeploymentEnvironmentType } from "./SystemConfigConstants";
import { ServiceUrlConfig } from "./ServiceUrlConfigJs";
import { BaseLayerConfig } from "./BaseLayerConfig";

import AxiosConfig from "./AxiosConfigJs";
import { TdtUser } from "../components/onlineMap/model/TdtUserJs";

export class SystemConfig
{   
    constructor()
    {   

        
    }



    //初始化
    init()
    {   
        
        let urlConfigInstance = ServiceUrlConfig.getInstance();
        urlConfigInstance.token=SystemConfig.token;
        urlConfigInstance.envType=SystemConfig.deployEnvType;
        urlConfigInstance.init();


        //初始化底图配置
        let blConfigInstance= BaseLayerConfig.getInstance();
        blConfigInstance.envType=SystemConfig.deployEnvType;
        blConfigInstance.init();
        

        //初始化axios配置
        AxiosConfig.config();
        
        //设置天地图用户环境
        if (SystemConfig.deployEnvType === DeploymentEnvironmentType.publicNetwork) {
            TdtUser.envIsPublic=true;
        }
        else if(SystemConfig.deployEnvType===DeploymentEnvironmentType.governmentNetWork)
        {
            TdtUser.envIsPublic=false;
        }
    }   


    static getInstance()
    {   
        if(!SystemConfig._instance)
        {
            SystemConfig._instance=new SystemConfig();
        }

        return SystemConfig._instance;
    }


}

SystemConfig._instance=null;

//请求时的token值，正式环境
// SystemConfig.token="ebddfc3f34215c7375bddd93f03dd684";
SystemConfig.token="dc177139441544394c0f78af3eb92de2"

//请求时的token值，本地测试用
SystemConfig.token="dc177139441544394c0f78af3eb92de2";



//部署环境
SystemConfig.deployEnvType=DeploymentEnvironmentType.publicNetwork;